import React from "react";
import HeaderPageItem from "../custom/HeaderPageItem";
import PageContainer from "../custom/Page";
import ReportsMenu from "./components/ReportsMenu";

const MenuReports = () => {
  return (
    <PageContainer>
      <HeaderPageItem title="app.reports" />
      <ReportsMenu enableManagerReportSection />
    </PageContainer>
  );
};

export default MenuReports;
